<mat-card-header>
	<mat-card-title>
		Edit Help Text ({{helpTextId}})

		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>

		<button *ngIf="data" class="close-button" mat-mini-fab (click)="closeDialog(false)">
			<mat-icon>close</mat-icon>
		</button>
	</mat-card-title>
	<mat-card-subtitle>
		<div *ngIf="editHelpText.createdBy">Created by {{editHelpText.createdBy}} ({{editHelpText.createdDate! |
			simpleDateTime}})</div>
		<div *ngIf="editHelpText.modifiedBy">Last Modified by {{editHelpText.modifiedBy}} ({{editHelpText.modifiedDate!
			| simpleDateTime}})</div>

		<label>Route Url Tags</label>
		<mat-chip-set #chipGridRouteUrls *ngIf="editHelpText.routeUrls && editHelpText.routeUrls.length > 0">
			<mat-chip-row *ngFor="let routeUrl of editHelpText.routeUrls;" (removed)="removeRouteUrl(routeUrl)">
				{{routeUrl}}
				<button matChipRemove [attr.aria-label]="'remove'">
					<mat-icon>cancel</mat-icon>
				</button>
			</mat-chip-row>
		</mat-chip-set>

	</mat-card-subtitle>
</mat-card-header>
<mat-card-content *ngIf="!isLoading">
	<hr />
	<div class="row">
		<div class="col-sm-6">
			<form (ngSubmit)="submit()">
				<div class="row">

					<mat-form-field class="col-lg-12">
						<mat-label>
							Header text
						</mat-label>
						<input matInput id="helpTextHeader" name="helpTextHeader" type="string"
							[(ngModel)]="editHelpText.header!.text" />
					</mat-form-field>
				</div>
				<hr />
				<div class="row">
					<div class="col-lg-12" *ngFor="let body of editHelpText.bodies; let i = index;">
						<mat-form-field class="w-100">
							<mat-label>
								Help text body
							</mat-label>
							<textarea matInput [id]="'helpTextBody' + i" [name]="'helpTextBody' + i" type="string"
								[(ngModel)]="body.text" cdkTextareaAutosize #autosize="cdkTextareaAutosize"></textarea>
							<button type="button" matSuffix mat-icon-button aria-label="bold"
								[color]="body.bold ? 'primary' : ''" (click)="toggleBold(body)">
								<mat-icon>format_bold</mat-icon>
							</button>
							<button type="button" matSuffix mat-icon-button aria-label="list item"
								[color]="body.listItem ? 'primary' : ''" (click)="toggleListItem(body)">
								<mat-icon>radio_button_checked</mat-icon>
							</button>
							<button type="button" matSuffix mat-icon-button aria-label="search" color="warn"
								(click)="removeBody(i)">
								<mat-icon>remove</mat-icon>
							</button>
						</mat-form-field>
					</div>

					<div class="col-lg-12">
						<button type="button" mat-raised-button color="primary" (click)="addBody()">
							Add New Line
						</button>
					</div>
				</div>
				<hr />
				<div class="row">
					<mat-form-field class="col-lg-12">
						<mat-label>
							Footer text
						</mat-label>
						<input matInput id="helpTextFooter" name="helpTextFooter" type="string"
							[(ngModel)]="editHelpText.footer!.text" />
					</mat-form-field>
				</div>
			</form>
		</div>
		<div class="col-sm-6">
			<div class="row">
				<div class="col-lg-12">
					<div class="h3">Preview</div>
					<hr />
					<preview-help-text [helpText]="editHelpText"></preview-help-text>
				</div>
			</div>
		</div>
	</div>
	<hr />
</mat-card-content>
<mat-card-actions *ngIf="!isLoading">
	<button type="submit" mat-raised-button color="primary" [disabled]="!checkValid()" (click)="submit()">
		Save
	</button>
	<confirm-popover *ngIf="editHelpText.createdBy" class="margin-left-xs" [type]="'button'"
		[buttonTxt]="'Delete Help Text'" [popoverMsg]="'Are you sure you want to delete this Help Text?'"
		[color]="'warn'" (onConfirm)="deleteHelpText()" [disabled]="isSaving">
	</confirm-popover>
</mat-card-actions>